// extracted by mini-css-extract-plugin
module.exports = {"root":"FullViewMessage_root__1xPvq"};